<template>
	<div id="app">
		<!-- <keep-alive exclude=""> -->
			<router-view v-if="!platform_pc"></router-view>
			<template v-if="platform_pc">
				<keep-alive exclude="About,ProductInfo,NewsInfo,SupportInfo,jobInfo">
					<router-view></router-view>
				</keep-alive>
			</template>
		<!-- </keep-alive> -->
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {},
	data: function () {
		return {
			platform_pc: null,  //pc
		}
	},
	created(){
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Huawei|HONOR|OpenHarmony|HarmonyOS/i.test(navigator.userAgent) || isiPad) {
			this.platform_pc = true;
		}else {
			this.platform_pc = false;
		}
	},
	mounted() {
		//
	}
}
</script>
<style>
@charset "utf-8";
@font-face {
	font-family: 'PFFont';
	src: url('./assets/fonts/PingFang Medium.ttf');
}
@font-face {
	font-family: 'Light';
	src: url('./assets/fonts/Varta-Light.ttf');
}
@font-face {
	font-family: 'Medium';
	src: url('./assets/fonts/Varta-Medium.ttf');
}
@font-face {
	font-family: 'Regular';
	src: url('./assets/fonts/Varta-Regular.ttf');
}
::-webkit-input-placeholder{color:#999999;}
/* ::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;} */
*{
	font-family: "Medium", "Helvetica", 'Arial';
	outline:none;
	text-decoration:none;
	box-sizing:border-box;
	-webkit-tap-highlight-color:rgba(0,0,0,0);
	touch-action: pan-y;
	word-wrap: normal;letter-spacing: 0px;
/* word-break: break-all; */}
img{vertical-align:top;}
html,body{width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling: touch;}
input,div,span,select,textarea,button{line-height: 1.6;}
input{-webkit-appearance: none;}
/*按钮*/
.public_btn{
	display: inline-block;
	font-size: 16px;
	padding: 8px 18px 8px 20px;
	border-radius: 8px;
	border: 1px solid #999999;
	line-height: 1;
	cursor: pointer;
}
.h5_public_btn{
	display: inline-block;
	font-size: 14px;
	padding: 4px 10px 4px 14px;
	border-radius: 8px;
	border: 1px solid #A50073;
	line-height: 1;
	color: #A50073;
}
.public_btn .btn_icon{
	display: inline-block;
	top: 2px;
	margin-left: 4px;
}
.h5_public_btn .btn_icon{
	display: inline-block;
	top: 3px;
	margin-left: 4px;
}
/*位置PC*/
.location_box{
	padding: 20px;
	border-bottom: 1px solid #F7F5F7;
}
.location_box .location_main{
	width: 1264px;
	margin: 0 auto;
	text-align: right;
}
.location_box .location_main span{
	font-size: 18px;
}
.location_box .location_main .actived{
	color: #A20073;
}
.main_box .el-loading-spinner .path{
	stroke: #A50073;
}
/* .main_box .el-loading-mask{
	background-color: transparent;
} */
/*loading*/
.loading{width:100%;height:100%;position:fixed;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
</style>